import {
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ImageUpload from '../components/common/ImageUpload';
import { SettingContext } from '../components/ui/layouts/main.layout';
import useAPI from '../hooks/useAPI';
import useDebounce from '../hooks/useDebounce';
import styles from './SettingsPage.module.scss';

export default function SettingsPage() {
  const { themeSetting, setThemeSetting } = useContext(SettingContext);
  const [newColor, setNewColor] = useState(themeSetting?.activeColor);
  const debouncedNewValue = useDebounce(newColor, 1000);
  const renderFlag = useRef(false);

  const { refetch: updateSettings, isLoading: isUpdatingSettings } = useAPI({
    url: '/setting/create',
    method: 'POST',
    onError: error => {
      toast.error(error?.response?.data?.message || 'An error occurred');
    },
  });

  console.log({ themeSetting });

  const { refetch: uploadLogo, isLoading } = useAPI({
    url: '/upload/image',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    isFormData: true, // important to tell the hook we're uploading FormData
    onSuccess: responseData => {
      if (responseData?.result) {
        updateSettings({
          brandLogo: responseData?.result,
        });
        setThemeSetting({
          logo: responseData.result, // assuming result contains the logo URL
          activeColor: themeSetting.activeColor,
        });
      }
    },
    onError: error => {
      toast.error(error?.response?.data?.message || 'An error occurred');
    },
  });

  const handleLogoChange = (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    uploadLogo(formData);
  };

  const handleColorChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    setNewColor(newColor);
    setThemeSetting({
      logo: themeSetting.logo,
      activeColor: newColor,
    });
    setCSSVariables(newColor);
  };

  const setCSSVariables = (color: string) => {
    document.documentElement.style.setProperty('--primary', color);
    document.documentElement.style.setProperty('--primary-50', color + '40');
  };

  useEffect(() => {
    if (renderFlag.current) {
      updateSettings({ primaryColour: debouncedNewValue });
    }
    renderFlag.current = true;
  }, [debouncedNewValue]);

  return (
    <>
      <div className="d-flex flex-column flex-wrap justify-content-between">
        <div className="d-flex align-items-center mb-2">
          <h2 className="mb-0 fw-bold">Settings</h2>
          {isUpdatingSettings && (
            <span className="d-flex align-items-center gap-2 badge rounded-pill bg-light text-secondary">
              <Spinner
                animation="border"
                role="status"
                variant="primary"
                size={'sm'}
              />
              Updating...
            </span>
          )}
        </div>
        <div
          className={`bg-white rounded-3 shadow-sm ${styles.settingsContainer}`}
        >
          <div className="p-4">
            <h4 className="mb-4 text-xl fw-bold mb-6">Customization</h4>

            {/* Branding Section */}
            <div className="space-y-6">
              <p className="mb-3 text-sm fw-bold text-gray-500 uppercase tracking-wider">
                BRANDING
              </p>
            </div>

            <Row className={`mb-3 ${styles.formRow}`}>
              <Col xs={12} md={3}>
                <p className="fw-semibold">Upload Your Brand Logo</p>
              </Col>
              <Col xs={12} md={9}>
                <ImageUpload
                  accept={['image/png', 'image/jpeg', 'image/jpg']}
                  name="image"
                  initialImage={themeSetting?.logo}
                  onImageChange={handleLogoChange}
                />
              </Col>
            </Row>
            <Row className={styles.formRow}>
              <Col xs={12} md={3}>
                <p className="fw-semibold">Primary Colour</p>
              </Col>
              <Col xs={12} md={9}>
                {/* <Form.Control
                  type="color"
                   key={themeSetting?.activeColor}
                  id="exampleColorInput"
                  value={themeSetting?.activeColor}
                  title="Choose your color"
                  onChange={handleColorChange}
                  disabled={isLoading}
                /> */}
                <input
                  type="color"
                  value={themeSetting?.activeColor}
                  onChange={handleColorChange}
                  style={{ border: 'none' }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}
